var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967712V138.565H177.903V0.435486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_362)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 170,
    height: 133
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.429 5.01613H4.57068V137.984H173.429V5.01613Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4559 133.033H166.544",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0755 102.454C24.2566 102.454 25.3319 101.758 25.8001 100.673C27.405 96.9566 31.1011 94.3546 35.4074 94.3546H85.4042C89.7103 94.3546 93.4066 96.9566 95.0115 100.673C95.4797 101.758 96.5548 102.454 97.7361 102.454C98.9523 102.454 100.022 103.344 100.153 104.554C100.307 105.978 99.1957 107.182 97.803 107.182H97.7363C96.5552 107.182 95.4799 107.878 95.0117 108.962C93.4068 112.679 89.7106 115.281 85.4044 115.281H35.4072C31.1011 115.281 27.4048 112.679 25.7999 108.962C25.3317 107.878 24.2566 107.182 23.0753 107.182H23.0086C21.6649 107.182 20.5831 106.061 20.6471 104.704C20.707 103.432 21.8026 102.454 23.0755 102.454Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0755 81.5266C24.2566 81.5266 25.3319 80.8307 25.8001 79.7465C27.405 76.0296 31.1011 73.4276 35.4074 73.4276H85.4042C89.7103 73.4276 93.4066 76.0296 95.0115 79.7465C95.4797 80.8309 96.5548 81.5266 97.7361 81.5266C98.9523 81.5266 100.022 82.4175 100.153 83.6266C100.307 85.0508 99.1957 86.2551 97.803 86.2551H97.7363C96.5552 86.2551 95.4799 86.9511 95.0117 88.0353C93.4068 91.7522 89.7106 94.3542 85.4044 94.3542H35.4072C31.1011 94.3542 27.4048 91.7522 25.7999 88.0353C25.3317 86.9509 24.2566 86.2551 23.0753 86.2551H23.0086C21.6649 86.2551 20.5831 85.1342 20.6471 83.7765C20.707 82.5049 21.8026 81.5266 23.0755 81.5266Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8016 65.3289H97.7363C96.5543 65.3289 95.4799 66.0246 95.0109 67.1087C93.4061 70.8256 89.7103 73.428 85.4033 73.428H35.4068C31.1017 73.428 27.4057 70.8258 25.8011 67.1087C25.3321 66.0246 24.2558 65.3289 23.0757 65.3289H23.0084C21.665 65.3289 20.5829 64.2064 20.6463 62.8497C20.7078 61.5774 21.8033 60.5991 23.0757 60.5991C24.2558 60.5991 25.3321 59.9033 25.8011 58.8193C27.4059 55.1024 31.1017 52.5 35.4068 52.5H85.4035C89.7105 52.5 93.4064 55.1024 95.0111 58.8193C95.4801 59.9033 96.5545 60.5991 97.7365 60.5991C98.3438 60.5991 98.9166 60.822 99.351 61.1968C99.7872 61.5697 100.087 62.0944 100.152 62.6998C100.306 64.1238 99.1951 65.3289 97.8016 65.3289Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4033 115.281H35.4066C31.1013 115.281 27.4054 112.678 25.8005 108.963C25.3315 107.877 24.2571 107.182 23.0751 107.182H23.0078C21.6644 107.182 20.5842 106.061 20.6476 104.704C20.7072 103.432 21.8028 102.453 23.0751 102.453C24.2571 102.453 25.3315 101.758 25.8005 100.674C27.4054 96.9566 31.1013 94.3542 35.4066 94.3542H60.8384",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6341 73.4276H35.4066C31.1013 73.4276 27.4054 76.0299 25.8005 79.7471C25.3315 80.8311 24.2571 81.5268 23.0751 81.5268C21.8028 81.5268 20.7072 82.5051 20.6476 83.7775C20.5842 85.1344 21.6644 86.2549 23.0078 86.2549H23.0751C24.2571 86.2549 25.3315 86.9507 25.8005 88.0347C27.4054 91.7518 31.1013 94.3542 35.4066 94.3542H60.8384",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8663 53.116C32.9714 52.7181 34.1631 52.501 35.4066 52.501H58.4186",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7576 57.083C26.3848 57.6269 26.0638 58.2093 25.8005 58.8205C25.3315 59.9045 24.2571 60.6002 23.0751 60.6002C21.8028 60.6002 20.7072 61.5785 20.6476 62.8489C20.5842 64.2078 21.6644 65.3283 23.0078 65.3283H23.0751C24.2571 65.3283 25.3315 66.0241 25.8005 67.1081C27.4054 70.8252 31.1013 73.4276 35.4066 73.4276H61.6341",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.617 125.637H20.1934C18.8357 125.637 17.7351 124.536 17.7351 123.178V119.504C17.7351 118.146 18.8357 117.046 20.1934 117.046H100.617C101.975 117.046 103.076 118.146 103.076 119.504V123.178C103.076 124.536 101.975 125.637 100.617 125.637Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7795 125.637H25.4205V132.807H38.7795V125.637Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1341 125.637H82.7751V132.807H96.1341V125.637Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.097 16.6323L122.42 14.5516C124.256 13.4027 126.592 13.4292 128.401 14.6195L131.273 16.5096C131.926 16.9397 132.663 17.2263 133.436 17.3507L137.419 17.992C139.647 18.3509 141.434 20.0269 141.936 22.2277L142.487 24.651C142.711 25.6345 143.2 26.538 143.9 27.2641L146.365 29.8208C147.903 31.415 148.342 33.7722 147.481 35.813L146.188 38.8803C145.852 39.6772 145.708 40.5417 145.766 41.4044L145.971 44.4305C146.113 46.5198 145.063 48.5101 143.259 49.5732L140.299 51.3173C139.694 51.6739 139.162 52.1424 138.732 52.6979L136.381 55.7349C135.154 57.3198 133.166 58.1176 131.184 57.8208L126.49 57.1177C125.792 57.0132 125.08 57.0431 124.393 57.206L121.006 58.0092C119.071 58.4679 117.039 57.8537 115.682 56.4001L112.076 52.5366C111.748 52.185 111.375 51.8777 110.968 51.6224L107.348 49.3555C105.426 48.1514 104.433 45.8962 104.842 43.6651L105.192 41.7609C105.4 40.6269 105.249 39.4561 104.76 38.4122L103.599 35.9362C102.705 34.0299 102.971 31.7818 104.283 30.1358L106.151 27.7943C106.503 27.353 106.785 26.8604 106.988 26.3337L108.77 21.7085C109.448 19.9493 110.975 18.6562 112.822 18.277L117.273 17.3628C117.92 17.23 118.538 16.9827 119.097 16.6323Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.496 50.9027C133.763 50.9027 140.465 44.2007 140.465 35.9333C140.465 27.6659 133.763 20.9639 125.496 20.9639C117.229 20.9639 110.526 27.6659 110.526 35.9333C110.526 44.2007 117.229 50.9027 125.496 50.9027Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.579 37.8138L121.725 41.7006L133.385 30.9903",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.991 113.109L106.139 123.638C105.561 126.92 108.087 129.929 111.42 129.929H152.347C155.68 129.929 158.206 126.92 157.628 123.638L155.776 113.109C154.107 103.617 154.107 93.9069 155.777 84.4153L157.628 73.8879C158.206 70.6053 155.68 67.5968 152.347 67.5968H111.42C108.087 67.5968 105.561 70.6053 106.139 73.8879L107.99 84.4152C109.66 93.9071 109.66 103.617 107.991 113.109Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.744417c81e14f197cd672ccb67443824.svg";
export { ForwardRef as ReactComponent };